import initObjectsTable from "./components/datatables";
import initMasonry from "./components/macy";
import addAccordion from "./components/accordion";
import AOS from "aos";
import { initHeroGallerySlider } from "./components/sliders";

function openMenu() {
  function init() {
    const hamburger = document.querySelector(".hamburger");
    const menu = document.querySelector(".mobile-menu");

    hamburger.addEventListener("click", () => {
      hamburger.classList.toggle("is-active");
      menu.classList.toggle("is-open");
      document.body.classList.toggle("mobile-menu-open");
    });

    const items = document.querySelectorAll(".primary-mobile-nav a");

    items.forEach((item) => {
      item.addEventListener("click", () => {
        hamburger.click();
      });
    });
  }

  const isPresent = document.getElementsByClassName("hamburger");
  if (isPresent.length > 0) {
    init();
  }
}

function runOnLoadAndDocumentReady() {
  initObjectsTable();
  initMasonry();
  addAccordion();
  initMasonry();
  openMenu();
  initHeroGallerySlider();

  function toggleToTopClass() {
    if (window.innerWidth < 600) {
      if (window.scrollY >= 1000) {
        document.body.classList.add("to-top-visible");
      } else {
        document.body.classList.remove("to-top-visible");
      }
    } else {
      document.body.classList.remove("to-top-visible"); // Ensure class is removed on larger screens
    }
  }

  window.addEventListener("scroll", toggleToTopClass);
  window.addEventListener("resize", toggleToTopClass); // Re-check on resize

  AOS.init({
    startEvent: 'load',
    duration: 500, // values from 0 to 3000, with step 50ms
    once: true,
  });

  const backButton = document.querySelector(".back-button");
  if (backButton) {
    backButton.addEventListener("click", function () {
      var referrer = document.referrer;
      var homeUrl = backButton.getAttribute("data-home-url");
      if (referrer.indexOf(window.location.hostname) !== -1) {
        window.history.back();
      } else {
        window.location.href = homeUrl;
      }
    });
  }

  const observer = new IntersectionObserver(function (entries) {
    if (!entries[0].isIntersecting) {
      document.body.classList.add("header-scrolled");
    } else {
      document.body.classList.remove("header-scrolled");
    }
  });

  observer.observe(document.querySelector(".header-observer"));

  const header = document.querySelector(".hero");
  const headObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          document.body.classList.add("header-out");
        } else {
          document.body.classList.remove("header-out");
        }
      });
    },
    { root: null, threshold: 0 }
  );

  if (header) {
    headObserver.observe(header);
  }
}

if (document.readyState !== "loading") {
  runOnLoadAndDocumentReady();
} else {
  document.addEventListener("DOMContentLoaded", function () {
    runOnLoadAndDocumentReady();
  });
}
